var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Divider, Stack } from "@mui/material";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { Allergy, COMMON_PREFERENCE_TYPES, DietType, Interest, } from "../../models/profile/preference.model";
import { LoadingButton } from "@mui/lab";
import { useMutation } from "react-query";
import { ProfileService } from "../../services/profile/profile.service";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { labelizeUnderScoreText, useLocalize } from "../../utils/text.util";
import { Add, Save } from "@mui/icons-material";
import { useReadOnly } from "../../utils/hooks/users/useReadOnly";
import { AllergyElement } from "../uiElements/AllergyElement";
import { DietElement } from "../uiElements/DietElement";
import { MedicalElement } from "../uiElements/MedicalElement";
import { InterestElement } from "../uiElements/InterestElement";
import { ElementChip } from "../uiElements/base/ElementChip";
// Renamed component as it now serves Interests quick editor as well
var ProfileQuickPreferenceEditor = function (_a) {
    var _b;
    var open = _a.open, profile = _a.profile, setProfile = _a.setProfile, preferenceTypes = _a.preferenceTypes;
    var _c = useLocalize(), t = _c.t, tFallback = _c.tFallback;
    // Read-only users may view preferences, but not add, remove or save them.
    var readOnly = useReadOnly();
    var _d = useState(), tmpProfile = _d[0], setTmpProfile = _d[1];
    var _e = useState({}), tmpPreference = _e[0], setTmpPreference = _e[1];
    var preferenceMap = (_b = {},
        _b[COMMON_PREFERENCE_TYPES.CRQLAR_INTERESTS] = {
            title: t('Interests'),
            preferenceType: COMMON_PREFERENCE_TYPES.CRQLAR_INTERESTS,
            keys: Object.keys(Interest),
        },
        _b[COMMON_PREFERENCE_TYPES.CRQLAR_FOOD_ALLERGY] = {
            title: t('Allergies'),
            preferenceType: COMMON_PREFERENCE_TYPES.CRQLAR_FOOD_ALLERGY,
            keys: Object.keys(Allergy),
        },
        _b[COMMON_PREFERENCE_TYPES.CRQLAR_FOOD_TYPE] = {
            title: t('Diets'),
            preferenceType: COMMON_PREFERENCE_TYPES.CRQLAR_FOOD_TYPE,
            keys: Object.keys(DietType),
        },
        _b[COMMON_PREFERENCE_TYPES.CRQLAR_MEDICAL] = {
            title: t('Medical'),
            preferenceType: COMMON_PREFERENCE_TYPES.CRQLAR_MEDICAL,
            keys: [],
        },
        _b);
    useEffect(function () {
        if (open) {
            setTmpProfile(profile);
        }
    }, [open, profile]);
    var updateProfileMut = useMutation(['updateProfile', tmpProfile === null || tmpProfile === void 0 ? void 0 : tmpProfile.id], function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!tmpProfile)
                        return [2 /*return*/];
                    return [4 /*yield*/, ProfileService.updateProfile(tmpProfile)];
                case 1:
                    response = _a.sent();
                    setTmpProfile(response);
                    setProfile(response);
                    return [2 /*return*/];
            }
        });
    }); });
    var getPreferenceLabel = function (preferenceType, value) {
        var translationKey = preferenceType === COMMON_PREFERENCE_TYPES.CRQLAR_MEDICAL
            ? "Common health preference value ".concat(value)
            : "".concat(preferenceType, "_").concat(value);
        return tFallback(translationKey, labelizeUnderScoreText(value));
    };
    var addPreference = function (preferenceType, preferenceValue) {
        setTmpProfile(function (currentProfile) {
            if (!currentProfile)
                return currentProfile;
            var preferences = currentProfile.preferences || [];
            var alreadyExists = preferences.some(function (preference) { return (preference.preferenceType === preferenceType
                && preference.preferenceValue === preferenceValue); });
            if (alreadyExists)
                return currentProfile;
            return __assign(__assign({}, currentProfile), { preferences: __spreadArray(__spreadArray([], preferences, true), [
                    { preferenceType: preferenceType, preferenceValue: preferenceValue },
                ], false) });
        });
    };
    var removePreference = function (preferenceToRemove) {
        setTmpProfile(function (currentProfile) { return currentProfile ? (__assign(__assign({}, currentProfile), { preferences: (currentProfile.preferences || [])
                .filter(function (preference) { return preference !== preferenceToRemove; }) })) : currentProfile; });
    };
    var addCustomPreference = function (preferenceType) {
        var _a;
        var value = (_a = tmpPreference[preferenceType]) === null || _a === void 0 ? void 0 : _a.trim();
        if (!value)
            return;
        addPreference(preferenceType, value);
        setTmpPreference(function (current) {
            var _a;
            return (__assign(__assign({}, current), (_a = {}, _a[preferenceType] = '', _a)));
        });
    };
    var renderProfilePreferenceElement = function (key, preferenceType, value, actions) {
        var label = getPreferenceLabel(preferenceType, value);
        switch (preferenceType) {
            case COMMON_PREFERENCE_TYPES.CRQLAR_INTERESTS:
            case COMMON_PREFERENCE_TYPES.CRQLAR_AI_GENERATED_INTERESTS:
                return (_jsx(InterestElement, __assign({ label: label, value: value, aiGenerated: preferenceType === COMMON_PREFERENCE_TYPES.CRQLAR_AI_GENERATED_INTERESTS }, actions), key));
            case COMMON_PREFERENCE_TYPES.CRQLAR_FOOD_ALLERGY:
                return _jsx(AllergyElement, __assign({ label: label, value: value }, actions), key);
            case COMMON_PREFERENCE_TYPES.CRQLAR_FOOD_TYPE:
                return _jsx(DietElement, __assign({ label: label, value: value }, actions), key);
            case COMMON_PREFERENCE_TYPES.CRQLAR_MEDICAL:
                return _jsx(MedicalElement, __assign({ label: label, value: value }, actions), key);
            default:
                return _jsx(ElementChip, __assign({ text: label }, actions), key);
        }
    };
    var renderPreferenceType = function (title, preferenceType, allOptions) {
        var _a, _b, _c;
        var currentPreferences = preferenceType === COMMON_PREFERENCE_TYPES.CRQLAR_INTERESTS
            ? ((_a = tmpProfile === null || tmpProfile === void 0 ? void 0 : tmpProfile.preferences) === null || _a === void 0 ? void 0 : _a.filter(function (p) { return p.preferenceType === COMMON_PREFERENCE_TYPES.CRQLAR_INTERESTS || p.preferenceType === COMMON_PREFERENCE_TYPES.CRQLAR_AI_GENERATED_INTERESTS; })) || []
            : ((_b = tmpProfile === null || tmpProfile === void 0 ? void 0 : tmpProfile.preferences) === null || _b === void 0 ? void 0 : _b.filter(function (p) { return p.preferenceType === preferenceType; })) || [];
        var allOptionsFiltered = allOptions.filter(function (o) { return !currentPreferences.find(function (cp) { return cp.preferenceValue === o; }); });
        return (_jsxs(Stack, __assign({ gap: 1, width: '330px' }, { children: [_jsx(Typography, __assign({ variant: 'h5' }, { children: title })), _jsx(Stack, __assign({ direction: 'row', gap: 1, flexWrap: 'wrap' }, { children: currentPreferences.map(function (pref, index) {
                        var _a;
                        var value = pref.preferenceValue;
                        if (!value)
                            return null;
                        var selectedPreferenceType = (_a = pref.preferenceType) !== null && _a !== void 0 ? _a : preferenceType;
                        var key = "selected-".concat(selectedPreferenceType, "-").concat(value, "-").concat(index);
                        return renderProfilePreferenceElement(key, selectedPreferenceType, value, { onDelete: readOnly ? undefined : function () { return removePreference(pref); } });
                    }) })), _jsx(Divider, {}), _jsx(Typography, __assign({ sx: { mt: 1 } }, { children: t('Add more') })), _jsx(Stack, __assign({ direction: 'row', alignItems: 'center', flexWrap: 'wrap', gap: 1 }, { children: allOptionsFiltered.map(function (value) {
                        var key = "available-".concat(preferenceType, "-").concat(value);
                        var onClick = readOnly
                            ? undefined
                            : function () { return addPreference(preferenceType, value); };
                        return renderProfilePreferenceElement(key, preferenceType, value, { onClick: onClick });
                    }) })), _jsx(Typography, __assign({ sx: { pt: 2, mt: "auto" } }, { children: t('Add custom') })), _jsxs(Stack, __assign({ direction: 'row', alignItems: 'center', gap: 1 }, { children: [_jsx(TextField, { placeholder: t('Custom'), value: tmpPreference[preferenceType] || '', onChange: function (e) {
                                setTmpPreference(function (current) {
                                    var _a;
                                    return (__assign(__assign({}, current), (_a = {}, _a[preferenceType] = e.target.value, _a)));
                                });
                            }, fullWidth: true, onKeyUp: function (e) {
                                if (e.key === "Enter") {
                                    addCustomPreference(preferenceType);
                                }
                            }, size: 'small', disabled: readOnly }), _jsx(Box, { children: _jsx(Button, __assign({ variant: 'contained', startIcon: _jsx(Add, {}), onClick: function () { return addCustomPreference(preferenceType); }, disabled: !((_c = tmpPreference[preferenceType]) === null || _c === void 0 ? void 0 : _c.trim()) || readOnly }, { children: t('Add') })) })] }))] }), preferenceType));
    };
    return (_jsxs(Stack, __assign({ gap: 2 }, { children: [_jsx(Typography, { children: t('Quick edit') }), _jsx(Stack, __assign({ gap: 4, direction: "row" }, { children: preferenceTypes.map(function (type) {
                    var pref = preferenceMap[type];
                    if (!pref)
                        return null;
                    return renderPreferenceType(pref.title, pref.preferenceType, pref.keys);
                }) })), _jsx(LoadingButton, __assign({ variant: 'contained', onClick: function () { return updateProfileMut.mutate(); }, loading: updateProfileMut.isLoading, startIcon: _jsx(Save, {}), disabled: readOnly }, { children: t('Save changes') }))] })));
};
export default ProfileQuickPreferenceEditor;
